import styled from "styled-components";

export const ContactContainer = styled.div`
    height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: antiquewhite;

    @media screen and (max-width: 1024px) {
        height: 380px;
    }
    @media screen and (max-width: 768px) {
        height: 600px;
    }
`;

export const ContactWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 0 10px;

    @media screen and (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;        
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`;

export const ContactCard = styled.div`
    background: #fff2f2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 280px;
    height: 200px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.5);
    transition: all 0.3s ease-in-out;
    padding: 20px;
    margin: 12px;
    &:hover{
        transform: scale(1.05);;
        transition: all 0.2s ease-in;
    }
`;

export const ContactH1 = styled.h1`
    font-size: 48px;
    color: #442E1E;
    margin-bottom: 12px;

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const ContactH2 = styled.h2`
    font-size: 1.2rem;
    margin-bottom: 10px;

    @media screen and (max-width: 480px){
        font-size: 16px;
    }
`;

export const ContactP = styled.div`
    font-size: 1rem;
    text-align: center;
`;

export const ContactIcon = styled.img`
    height: auto;
    max-height: 250px;
    width: 280px;
    margin-bottom: 10px;
    margin: auto;
`;

export const TopLine = styled.p`
    color: #2BBAE0;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;